import { Dialog } from '@mui/material'
import React from 'react'
import { useMemo } from 'react'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { MemoViewTrip } from './ViewTrip'
import { fetchCurrentState } from '../../../redux/features/customerViewSlice'
import DetailPage from '../../DetailPage/Index'
import { useRef } from 'react'
import { Helmet } from 'react-helmet'
import { useState } from 'react'

export default function ViewTripHome() {
  const data = useSelector(fetchCurrentState)

  const tripStateData = useMemo(() => data, [])

  const [detailPageId, setdetailPageId] = React.useState(null)
  const [isDefault, setisDefault] = useState(null)

  // const [open, setOpen] = React.useState(false)
  // const handleDetailPageOpen = useCallback((id) => {
  //   setOpen(true)
  //   setdetailPageId(id)
  // }, [])

  // const handleDetailPageClose = useCallback(() => {
  //   setOpen(false)
  // }, [])

  const [open, setOpen] = React.useState(
    window.location.hash === '#detail-page',
  )
  React.useEffect(() => {
    const onHashChange = () => setOpen(window.location.hash === '#detail-page')
    window.addEventListener('hashchange', onHashChange)

    return () => window.removeEventListener('hashchange', onHashChange)
  }, [])

  function handleDetailPageOpen(id, default_value) {
    window.location.hash = '#detail-page'
    setdetailPageId(id)
    setisDefault(default_value)
  }

  function handleDetailPageClose() {
    window.history.back()
  }

  console.log('>>>>TestComponent Rendered')

  return (
    <>
      <Helmet>
        <title>{tripStateData.display_name}</title>
        {/* <meta name="description" content="Lorem ipsum dolor sit amet" /> */}
      </Helmet>
      <MemoViewTrip
        tripStateData={tripStateData}
        handleDetailPageOpen={handleDetailPageOpen}
        detailPageState={open}
      />
      <Dialog
        fullScreen
        open={open}
        keepMounted
        hideBackdrop={true}
        // TransitionComponent={Transition}
        className="modal-width"
        PaperProps={{
          style: {
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
          },
        }}
      >
        {open && (
          <div>
            <DetailPage
              detailPageId={detailPageId}
              handleDetailPageClose={handleDetailPageClose}
              isDefault={isDefault}
            />
          </div>
        )}
      </Dialog>
    </>
  )
}
